
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DYNAMIC_PAGES/_slugs_entry",
      function () {
        return require("private-next-pages/DYNAMIC_PAGES/_slugs_entry.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DYNAMIC_PAGES/_slugs_entry"])
      });
    }
  